export default {
  errors: {
    'file-invalid-type': 'File is not allowed',
    'file-too-large': 'File is too large',
    'too-many-files': 'Too many files',
  },
  okButton: 'Ok',
  typeAndSizeHint: 'Only {{type}} files of {{size}} or less',
};
